import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentConfig {
  api: string;
  baseUrl?: string;
  webappUrl?: string;
  websiteUrl?: string;
  adminUrl?: string;
  socketUrl?: string;
  production: boolean;
  cmsToken?: string;
  imageKitWebsiteBaseUrl?: string;
  geminiApiKey?: string;
  geoapifyKey?: string;
  [x: string]: any;
}
